import { useState } from 'react'

import { useAuth } from '../../auth/AuthContext.js'
import { Button, type ButtonProps } from '../Button'
import { showToast } from '../Toast'

type SignOutButtonProps = Pick<ButtonProps, 'variant' | 'size' | 'className'>

export function SignOutButton({
  variant = 'ghost',
  size = 'md',
  className,
}: SignOutButtonProps): JSX.Element {
  const { signOut } = useAuth()
  const [signingOut, setSigningOut] = useState(false)

  async function handleSignOut() {
    setSigningOut(true)
    try {
      await signOut()
    } catch (err) {
      setSigningOut(false)
      showToast(err instanceof Error ? err.message : 'Unable to sign out.', 'error')
    }
  }

  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      className={className}
      loading={signingOut}
      aria-label="Sign out of Study Decks"
      onClick={() => void handleSignOut()}
    >
      Sign out
    </Button>
  )
}
